import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const BankOperationCommentsSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" gap="8px">
      {Array.from({ length: 2 }).map((_, i) => (
        <Box display="flex" flexDirection="column" gap="4px" key={i}>
          <Skeleton height={24} variant="rounded" width={180} />
          <Skeleton height={20} variant="text" width="100%" />
        </Box>
      ))}
    </Box>
  );
};
